/**
 * SkipLink — premier élément focalisable du shell, invisible tant qu'il n'a
 * pas le focus (SAAS-915).
 *
 * @remarks
 * Sans lui, un utilisateur clavier traverse le header et la sidebar à chaque
 * page avant d'atteindre le contenu. Pointe vers `#main-content`, l'id porté
 * par le panneau center dans les 3 shells (`Panel.tsx`, `MobileShell.tsx`,
 * `TabletShell.tsx`).
 *
 * `focus:` et non `focus-visible:` — un lien d'évitement doit apparaître sur
 * tout focus clavier, y compris un `Shift+Tab` qui reboucle sur le document ;
 * c'est le comportement attendu du pattern, pas seulement celui d'un
 * `:focus-visible` incertain sur `<a>` selon les navigateurs.
 */
export function SkipLink() {
  return (
    <a
      href="#main-content"
      className="bg-surface text-fg border-primary sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-(--z-top) focus:rounded-md focus:border focus:px-3 focus:py-2 focus:text-sm focus:font-medium focus:shadow-lg"
    >
      Passer au contenu principal
    </a>
  );
}
